import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { axios } from '../api';
import { BOTTOM_TOAST, generateErrorMsg } from '../utils';

import { Treatment } from '@/pages/types';

export const useGetLeadTreatments = (leadId: string) => {
  const [treatments, setTreatments] = useState<Treatment[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`funnel_sessions/${leadId}/user_treatments`)
      .then((response) => {
        setTreatments(response.data);
        setIsLoading(false);
        setIsError(false);
      })
      .catch((e) => {
        setIsError(true);
        setIsLoading(false);
        toast.error(generateErrorMsg(e), BOTTOM_TOAST);
      });
  }, [leadId]);

  return {
    treatments,
    isLoading,
    isError,
  };
};
